"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRemoteEntryCache = void 0;
const remoteEntryCache = new Map();
const initRemoteEntryCache = () => {
    window.remoteEntryCache = remoteEntryCache;
    return window.remoteEntryCache;
};
/**
 * Функция, которая возвращает кеш для загрузки remoteEntry файла
 * Если первый вызов функции, то инитится новый объект кеша
 */
const getRemoteEntryCache = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    if (window.remoteEntryCache) {
        return window.remoteEntryCache;
    }
    return initRemoteEntryCache();
};
exports.getRemoteEntryCache = getRemoteEntryCache;
